import SadFace from '../assets/imgs/sad-face.png';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {

  const navigate = useNavigate();
  
  return (
    <div className="p-5 w-screen h-full flex flex-col items-center justify-center">
      <div className="flex flex-col items-center bg-white mb-[30px] w-full p-5 rounded-lg shaow-lg">
        <img src={SadFace} className="w-[50%] mt-[30px] h-auto" alt="" />
        <h1 className="text-xl mt-[60px] font-medium text-black font-nunito text-center">Page not found !!</h1>
        <p className="text-sm px-5 font-nunito text-center mt-[20px]">
          The page you are looking for does not exist. Please check the URL or click the button below to go back to the home page.
          <br /> <br /> You can always reach out to us at the support section or email us directly at
          <strong className="text-black"> admin@medisupport.com</strong>
        </p>
        <button onClick={() => {
          navigate('/')
        }} className="bg-[#0080f3] text-white font-nunito text-sm px-5 py-3 w-full rounded-lg mt-[30px]">
          Go Home
        </button>
      </div>
    </div>
  );
}